<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item, key) in active_list" :key="key" :label="item.label" :name="item.value" v-show="Acs('/payment-count/' + item.value)"></el-tab-pane>
            </el-tabs>
            <PaymentAnalysis v-if="activeName == 'payment-analysis'" :activeName="activeName" :key="1" @handleView="handleView"></PaymentAnalysis>
            <PaymentDetail v-else-if="activeName == 'payment-detail'" :activeName="activeName"></PaymentDetail>
        </div>
    </div>
</template>
  <style scoped>
  
  </style>
  <script>
  import PaymentAnalysis from "~/views/count/table/paymentAnalysis.vue";
  import PaymentDetail from "~/views/count/table/paymentDetail.vue";
  export default {

    components: {
      PaymentAnalysis,
        PaymentDetail
    },
  
    props: {
        
    },
  
    data() {
      return {
        activeName: '',
        active_list: [
          {
            label: '回款分析',
            value: 'payment-analysis',
          },
          {
            label: '回款明细汇总',
            value: 'payment-detail',
          },
        ],
      };
    },
  
    mounted() {

    },
  
    created() {
      this.activeName = this.$route.query['activeName'] ? this.$route.query['activeName'].toString() : '';
      this.active_list = this.active_list.filter(item=>{
        if(!this.Acs('/payment-count/' + item.value)){
          return false;
        }else if(!this.activeName){
          this.activeName = item.value;
        }
        return true;
      })
    },
  
    methods: {
        handleClick(tab, event) {

        },

        // 查看
        handleView(query) {
          query['activeName'] = 'payment-detail';
          let routeData = this.$router.resolve({
              path: "/count/payment",
              query: query,
          });
          window.open(routeData.href, '_blank');
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/payment.vue